const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isWeekPassed(date: Date): boolean {
    const timestamp = date.getTime();

    if (Number.isNaN(timestamp)) {
        return false;
    }

    return Date.now() - timestamp >= WEEK_MS;
}
